import { type BlogFrontmatter } from "@/services/blog.ts";
// eslint-disable-next-line no-restricted-imports
import headerImage from "./header_image.avif";
// eslint-disable-next-line no-restricted-imports
import { height, width } from "./header_image.avif?as=metadata:height;width";
// eslint-disable-next-line no-restricted-imports
import headerImageSrcset from "./header_image.avif?w=480;960;1920&format=avif&as=srcset";

export const frontmatter: BlogFrontmatter = {
  title: "Title which ends up in tab title",
  header: "Post Header shown as h1",
  date: "2025-04-15",
  description: "My description here",
  category: "company",
  draft: true,
  authorKey: "oscar_reimer",
  headerImage,
  headerImageSrcset,
  headerImageDimensions: {
    height,
    width,
  },
};
